const getAnonymousId = () => {
  const anonymousId = localStorage.getItem('ajs_anonymous_id')
  if (typeof anonymousId === 'string') return anonymousId.replace(/"/g, '')
  return anonymousId
}

export { getAnonymousId }
